function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { motion, AnimatePresence } from 'framer-motion';
import withStyles from 'isomorphic-style-loader/withStyles';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Link from 'components/Link';
import DotsIcon from 'svg/dots.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import * as constants from '../constants';
import * as shapes from '../shapes';
import messages from '../messages';
import styles from './OrganizationAdmin.pcss';
var _React_PureComponent;
class OrganizationMembershipBox extends (_React_PureComponent = React.PureComponent) {
    async onOpenMenu(evt) {
        evt.preventDefault();
        const { identityUID } = this.props.organizationMembership;
        await this.props.onCloseDropdown();
        this.props.onOpenDropdown(`${constants.ORGANIZATION_MEMBERSHIP_DROPDOWN}-${identityUID}`);
    }
    renderImage() {
        const { organizationMembership = {}, isPlaceholder } = this.props;
        const img = isPlaceholder ? /*#__PURE__*/ _jsx("div", {
            className: styles.avatar
        }) : /*#__PURE__*/ _jsx(Avatar, {
            avatarImg: organizationMembership.details.avatar,
            name: [
                organizationMembership.details.firstName,
                organizationMembership.details.lastName
            ],
            className: styles.avatar,
            isRound: true
        });
        return /*#__PURE__*/ _jsx("figure", {
            className: styles.avatarFig,
            children: img
        });
    }
    renderHeader() {
        const { details } = this.props.organizationMembership;
        return /*#__PURE__*/ _jsxs("h3", {
            className: "text--bold mb-2",
            children: [
                details.firstName,
                " ",
                details.lastName
            ]
        });
    }
    renderInfo() {
        const { details } = this.props.organizationMembership;
        return /*#__PURE__*/ _jsx("p", {
            className: "text--small text--light",
            children: details.businessEmail
        });
    }
    renderDetails() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row align-items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: this.renderImage()
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col",
                    children: [
                        this.renderHeader(),
                        this.renderInfo()
                    ]
                })
            ]
        });
    }
    renderIsAdmin() {
        const { isAdmin, status } = this.props.organizationMembership;
        if (status === 'Pending') {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.labels[isAdmin ? 'yes' : 'no']));
    }
    renderScope() {
        const { scope } = this.props.organizationMembership;
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.scopes[scope]));
    }
    renderMenuAction(menuAction) {
        const { organizationMembership } = this.props;
        if (menuAction.getIsHidden && menuAction.getIsHidden(organizationMembership)) {
            return null;
        }
        return /*#__PURE__*/ _jsx("li", {
            className: "dropdownMenu__action",
            children: /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                labelMessage: messages.buttons[menuAction.key],
                onClick: ()=>menuAction.onClick(organizationMembership)
            })
        }, `${organizationMembership.identityUID}-${menuAction.key}`);
    }
    renderMenu() {
        if (!this.props.menuActions) {
            return null;
        }
        const { identityUID } = this.props.organizationMembership;
        if (this.props.openDropdownId !== `${constants.ORGANIZATION_MEMBERSHIP_DROPDOWN}-${identityUID}`) {
            return null;
        }
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                width: 0
            },
            animate: {
                width: 'auto'
            },
            exit: {
                width: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: "dropdownMenu__container",
            children: /*#__PURE__*/ _jsx("ul", {
                className: "dropdownMenu__actions",
                children: this.props.menuActions.map((menuAction)=>this.renderMenuAction(menuAction))
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "form-group form-group--one-liner text--base",
            children: /*#__PURE__*/ _jsxs("div", {
                className: " row align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-7",
                        children: this.renderDetails()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-2",
                        children: this.renderIsAdmin()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-2",
                        children: this.renderScope()
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-1 text--right",
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                to: "",
                                onClick: (evt)=>this.onOpenMenu(evt),
                                children: /*#__PURE__*/ _jsx(DotsIcon, {
                                    className: "dropdownMenu__icon"
                                })
                            }),
                            /*#__PURE__*/ _jsx(AnimatePresence, {
                                children: this.renderMenu()
                            })
                        ]
                    })
                ]
            })
        });
    }
}
_define_property(OrganizationMembershipBox, "propTypes", {
    // Explicit props
    organizationMembership: shapes.organizationMembership,
    menuActions: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        getIsHidden: PropTypes.func,
        onClick: PropTypes.func.isRequired
    })),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isPlaceholder: PropTypes.bool,
    // Implicit props
    openDropdownId: PropTypes.string,
    // Implicit actions
    onOpenDropdown: PropTypes.func,
    onCloseDropdown: PropTypes.func
});
_define_property(OrganizationMembershipBox, "defaultProps", {
    isPlaceholder: false
});
const mapStateToProps = (state)=>({
        openDropdownId: App.selectors.dropdown(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenDropdown: (dropdownId)=>dispatch(App.actions.openDropdown(dropdownId)),
        onCloseDropdown: ()=>dispatch(App.actions.closeDropdown())
    });
const ConnectedOrganizationMembershipBox = connect(mapStateToProps, mapDispatchToProps)(OrganizationMembershipBox);
export default withStyles(styles)(ConnectedOrganizationMembershipBox);
